<div class="firma-acta-container">
  <p-toast></p-toast>

  <div *ngIf="loading" class="loading-overlay">
    <div class="loading-content">
      <p-progressSpinner></p-progressSpinner>
      <p class="loading-text">Cargando datos del acta...</p>
    </div>
  </div>

  <div class="acta-wrapper" *ngIf="!loading">
    <div class="acta-header">
      <div class="header-main">
        <h1 class="acta-title">Acta de Entrega de EPP</h1>
        <div class="acta-number">
          <span class="label">Número:</span>
          <span class="value">{{actaData.numeroActa}}</span>
        </div>
      </div>
      
      <div class="header-info">
        <div class="info-item">
          <span class="label">Fecha:</span>
          <span class="value">{{actaData.fechaEntrega | date:'dd/MM/yyyy HH:mm'}}</span>
        </div>
        <div class="info-item">
          <span class="label">Lugar:</span>
          <span class="value">{{actaData.lugarEntrega}}</span>
        </div>
        <div class="info-item">
          <span class="label">Tipo:</span>
          <span class="value">{{actaData.tipoEntrega}}</span>
        </div>
        <div class="info-item">
          <span class="label">Estado:</span>
          <span class="value status-{{actaData.estado.toLowerCase()}}">{{actaData.estado}}</span>
        </div>
      </div>
    </div>

    <div class="acta-content" *ngIf="actaData">
      <div class="section-container">
        <div class="empleados-section">
          <div class="empleado-card">
            <div class="card-header">
              <i class="pi pi-user-plus"></i>
              <h3>Empleado que Recibe</h3>
            </div>
            <div class="card-content">
              <div class="info-row">
                <span class="label">Nombre:</span>
                <span class="value">{{actaData.empleadoRecibe.nombre}}</span>
              </div>
              <div class="info-row" *ngIf="actaData.empleadoRecibe.cargo !== 'N/A'">
                <span class="label">Cargo:</span>
                <span class="value">{{actaData.empleadoRecibe.cargo}}</span>
              </div>
              <div class="info-row" *ngIf="actaData.empleadoRecibe.area !== 'N/A'">
                <span class="label">Área:</span>
                <span class="value">{{actaData.empleadoRecibe.area}}</span>
              </div>
              <div class="info-row">
                <span class="label">Email:</span>
                <span class="value email">{{actaData.empleadoRecibe.email}}</span>
              </div>
            </div>
          </div>

          <div class="empleado-card">
            <div class="card-header">
              <i class="pi pi-user"></i>
              <h3>Empleado que Entrega</h3>
            </div>
            <div class="card-content">
              <div class="info-row">
                <span class="label">Nombre:</span>
                <span class="value">{{actaData.empleadoEntrega.nombre}}</span>
              </div>
              <div class="info-row" *ngIf="actaData.empleadoEntrega.cargo !== 'N/A'">
                <span class="label">Cargo:</span>
                <span class="value">{{actaData.empleadoEntrega.cargo}}</span>
              </div>
              <div class="info-row" *ngIf="actaData.empleadoEntrega.area !== 'N/A'">
                <span class="label">Área:</span>
                <span class="value">{{actaData.empleadoEntrega.area}}</span>
              </div>
              <div class="info-row">
                <span class="label">Email:</span>
                <span class="value email">{{actaData.empleadoEntrega.email}}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="bodega-section">
          <div class="info-card">
            <div class="card-header">
              <i class="pi pi-building"></i>
              <h3>Información de Bodega</h3>
            </div>
            <div class="card-content">
              <div class="info-row">
                <span class="label">Bodega:</span>
                <span class="value">{{actaData.bodega.nombre}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="elementos-section">
        <div class="section-header">
          <i class="pi pi-box"></i>
          <h3>Elementos a Entregar</h3>
          <div class="estado-entrega" *ngIf="yaFirmado">
            <span class="badge-entregado">
              <i class="pi pi-check-circle"></i>
              Elementos Entregados
            </span>
          </div>
        </div>
        <div class="table-container">
          <p-table [value]="actaData.elementos" 
                   [tableStyle]="{'min-width': '100%'}"
                   styleClass="custom-table">
            <ng-template pTemplate="header">
              <tr>
                <th>Elemento</th>
                <th>Descripción</th>
                <th>Cantidad</th>
                <th>Ficha Técnica</th>
                <th *ngIf="yaFirmado">Estado</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-elemento>
              <tr>
                <td class="elemento-name">{{elemento.nombre}}</td>
                <td class="elemento-desc">{{elemento.descripcion}}</td>
                <td class="elemento-cantidad">{{elemento.cantidad}}</td>
                <td class="elemento-ficha">{{elemento.fichaTecnica.titulo}}</td>
                <td *ngIf="yaFirmado" class="elemento-estado">
                  <span class="estado-entregado">
                    <i class="pi pi-check"></i>
                    Entregado
                  </span>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>

      <div class="observaciones-section" *ngIf="actaData.observaciones">
        <div class="info-card">
          <div class="card-header">
            <i class="pi pi-comment"></i>
            <h3>Observaciones</h3>
          </div>
          <div class="card-content">
            <p class="observaciones-text">{{actaData.observaciones}}</p>
          </div>
        </div>
      </div>

      <div class="firma-section">
        <div class="section-header">
          <i class="pi pi-pencil"></i>
          <h3>Firma de Recepción</h3>
        </div>
        
        <!-- Mostrar firma existente si ya está firmado -->
        <div class="firma-existente" *ngIf="yaFirmado && firmaExistente">
          <div class="firma-content">
            <p class="firma-instructions">
              <i class="pi pi-check-circle"></i>
              Firma registrada exitosamente
            </p>
            
            <div class="firma-display">
              <img [src]="firmaExistente" alt="Firma del empleado" class="firma-image">
            </div>
            
            <div class="firma-info">
              <p><strong>Estado:</strong> {{actaData.estado}}</p>
              <p><strong>Fecha de entrega:</strong> {{actaData.fechaEntrega | date:'dd/MM/yyyy HH:mm'}}</p>
            </div>
          </div>
        </div>

        <!-- Mostrar cuadro para firmar si no está firmado -->
        <div class="firma-nueva" *ngIf="!yaFirmado">
          <div class="firma-content">
            <p class="firma-instructions">
              Por favor, firme en el espacio a continuación para confirmar la recepción de los elementos:
            </p>
            
            <div class="canvas-container">
              <canvas #firmaCanvas
                     width="500"
                     height="200"
                     (mousedown)="startDrawing($event)"
                     (mousemove)="draw($event)"
                     (mouseup)="stopDrawing()"
                     (mouseleave)="stopDrawing()">
              </canvas>
            </div>

            <div class="firma-buttons">
              <button pButton
                      type="button"
                      label="Limpiar Firma"
                      icon="pi pi-eraser"
                      class="p-button-secondary"
                      (click)="limpiarFirma()">
              </button>
              <button pButton
                      type="button"
                      label="Confirmar y Firmar"
                      icon="pi pi-check"
                      class="p-button-primary"
                      (click)="guardarFirma()">
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="disclaimer">
        <div class="disclaimer-content">
          <i class="pi pi-info-circle"></i>
          <p>
            Al firmar este documento, confirmo que he recibido los elementos de protección personal detallados anteriormente
            y me comprometo a darles el uso adecuado y mantenerlos en buen estado.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
